export enum Field {
  RelatedMember = 'member',
  RelatedTransaction = 'transaction',
  RelatedItem = 'item',
  Email = 'email',
  IsEnglishAllowed = 'isEnglishAllowed',
  Message = 'message',
  Attachments = 'attachments',
}

export type FormModel = {
  [Field.RelatedMember]: number
  [Field.RelatedItem]: number
  [Field.Message]: string
  [Field.RelatedTransaction]: number
  [Field.Email]: string
  [Field.IsEnglishAllowed]: boolean
}
